import { Card, CardContent, Paper, styled, TableCell, tablePaginationClasses } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const PaperStyled = styled(Paper)(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  background: theme.palette.primary.main,
}));

export const TableCellStyled = styled(TableCell)(({ theme }) => ({
  color: 'white',
  padding: '1rem 3rem',
  width: '30%',
  background: theme.palette.primary.dark,
  borderBottomColor: theme.palette.secondary.dark,
}));

export const TableCellGroup = styled(TableCellStyled)(() => ({
  background: 'transparent',
  lineHeight: '1rem',
}));

export const CardStyled = styled(Card)(() => ({
  width: '100%',
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
  border: `0.06rem solid ${theme.palette.secondary.dark}`,
}));

export const CardContentStyled = styled(CardContent)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '2rem',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const TablePaginationStyles = {
  color: theme.palette.common.white,
  background: theme.palette.primary.main,

  [`& .${tablePaginationClasses.select}:focus`]: {
    backgroundColor: 'transparent',
  },

  [`& .${tablePaginationClasses.selectIcon}`]: {
    color: theme.palette.common.white,
  },
};
